var n=function(n){var l="",o=null==n?void 0:n.filter((function(n){return null==n?void 0:n.name}));return null==o||o.forEach((function(n,o){l=o>0?"".concat(l,"/").concat(null==n?void 0:n.name):null==n?void 0:n.name})),l};export{n as getLocationString};
//# sourceMappingURL=index.js.map
